import { ApiError } from '../api/client'

// Kleine Helfer für die Dialoge, die etwas eintragen: Fehlertext, Zeit,
// Zahlen. An EINER Stelle, weil Depot- und Ideendialoge dieselben Regeln
// brauchen — und aus "41,80" an beiden Stellen dasselbe werden muss.

/** Die Fehlermeldung des Servers, oder ein Satz, der weiterhilft. */
export function fehlertext(cause: unknown): string {
  if (cause instanceof ApiError) return cause.message
  return 'Die Änderung ist nicht angekommen. Verbindung prüfen und erneut versuchen.'
}

const zwei = (n: number) => String(n).padStart(2, '0')

/**
 * Jetzt, als Wert für ein `datetime-local`-Feld: lokale Zeit ohne Zone, auf
 * die Minute. `toISOString()` taugt dafür nicht — das liefert UTC, und um
 * 15:47 stünde dann 13:47 im Feld.
 */
export function jetztLokal(): string {
  const d = new Date()
  return `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`
       + `T${zwei(d.getHours())}:${zwei(d.getMinutes())}`
}

/** Der Tag in `n` Tagen, als Wert für ein `date`-Feld — lokal, nicht UTC. */
export function inTagen(n: number): string {
  const d = new Date()
  d.setDate(d.getDate() + n)
  return `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`
}

/**
 * Eine Eingabe „41,80" oder „41.80" als Dezimalzeichenkette für den Server.
 *
 * ALS ZEICHENKETTE, nicht als Zahl: Aus 41,80 darf unterwegs nicht
 * 41.799999 werden — bei einem Kurs, der den Einstand bestimmt, ist das der
 * Unterschied zwischen richtig und fast richtig.
 */
export function dezimal(text: string): string {
  return text.trim().replace(',', '.')
}

export function positiv(text: string): boolean {
  const n = Number(dezimal(text))
  return text.trim() !== '' && Number.isFinite(n) && n > 0
}

export function nichtNegativ(text: string): boolean {
  const n = Number(dezimal(text))
  return text.trim() !== '' && Number.isFinite(n) && n >= 0
}

export function leerOderNichtNegativ(text: string): boolean {
  return text.trim() === '' || nichtNegativ(text)
}
